/**
 * @generated SignedSource<<1942c42a69a0db62d0bfbdca015a6608>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Header_query$data = {
  readonly me: {
    readonly " $fragmentSpreads": FragmentRefs<"HeaderTrialWarning_me" | "Support_user" | "User_me">;
  } | null | undefined;
  readonly " $fragmentType": "Header_query";
};
export type Header_query$key = {
  readonly " $data"?: Header_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"Header_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HeaderTrialWarning_me"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "User_me"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Support_user"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d9fd91b64346c80bbebf4fdf1e7c4c29";

export default node;
